/** @jsxImportSource @emotion/react */
import ButtonBase from '@mui/material/ButtonBase';
import mikeSharedTheme from '../../styles/mikeSharedTheme';
import { css } from '@emotion/react'
import Support from '../../icons/Support.svg?react';
import { Tooltip } from '@mui/material';


interface IProps {
  /**
   * Click callback.
   */
  onClickCallBack?: () => void;
  tooltipTitle?: string;
  tooltipPlacement?: 
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';
  tooltipArrow?: boolean;  
}

const buttonStyle = css`
  display: flex;
  align-items: center;
  padding: 0 10px;
  position: relative;
  min-height: 60px;
  &:hover: {
    background-color: ${mikeSharedTheme.palette.text.disabled};
  };
  cursor: pointer;
`;

/**
 * @name MikeSupportMenuButton
 * @summary The support bottom, opening the support menu.
 */
export const MikeSupportMenuButton = (props: IProps) => {
  const { onClickCallBack, tooltipTitle, tooltipArrow, tooltipPlacement } = props;

  return (
    <Tooltip title={tooltipTitle} arrow={tooltipArrow} placement={tooltipPlacement}>
      <ButtonBase css={buttonStyle} onClick={onClickCallBack}>
        <Support />
      </ButtonBase>
    </Tooltip>
  );
};

export default MikeSupportMenuButton;
